/**
 * DOCU: Contains Methods for Firing Google Tag Manager Events
 * Author: Arjhay Frias
 * Contact: arjhay.frias@thecollective.ph
 * Created At: 05-13-2023
 * Updated At: 05-13-2023
 */
class Analytics {
  constructor() {

  }

  /**
   * DOCU: Send Lead Created Custom Event to Google Tag Manager
   */
  sendLeadCreated(source) {
    // fbq('track', 'Lead');
    dataLayer.push({
      'event': 'lead',
      'source': source
    });  
  }

  /**
   * DOCU: Send Add To Cart Custom Event to Google Tag Manager
   */
  sendAddToCart(source, product) {
    // fbq('track', 'AddToCart');
    dataLayer.push({
      'event': 'add_to_cart',
      'source': source,
      'product': product
    });  
  }

  /**
   * DOCU: Send View Content Custom Event to Google Tag Manager
   */
  sendViewContent(product) {
    // fbq('track', 'ViewContent');
    dataLayer.push({
      'event': 'view_content',
      'product': product
    });  
  }

  /**
   * DOCU: Send Click Banner Custom Event to Google Tag Manager
   */
  sendClickBanner(campaign) {
    // fbq('track', 'ViewContent');
    dataLayer.push({
      'event': 'click_banner',
      'campaign': campaign
    });  
  }
}